<template lang="pug">

        .ui.grid

            //- Vorderseite
            .four.columns.row(v-if='isFrontSideVisible')

                //- Vorderseite » Euro (CMYK)
                dropdown-field.column(
                    label='Vorderseite » Euro (CMYK)'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='front.cmyk'
                    v-model='frontCmyk'
                    v-if='front.cmyk.length'
                )

                //- Vorderseite » HKS
                dropdown-field.column(
                    label='Vorderseite » HKS'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='front.hks'
                    v-model='frontHks'
                    v-if='front.hks.length'
                )

                //- Vorderseite » Pantone
                dropdown-field.column(
                    label='Vorderseite » Pantone'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='front.pantone'
                    v-model='frontPantone'
                    v-if='front.pantone.length'
                )

                //- Vorderseite » RAL
                dropdown-field.column(
                    label='Vorderseite » RAL'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='front.ral'
                    v-model='frontRal'
                    v-if='front.ral.length'
                )

            //- Rückseite
            .four.columns.row(v-if='isBackSideVisible')

                //- Rückseite » Euro (CMYK)
                dropdown-field.column(
                    label='Rückseite » Euro (CMYK)'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='back.cmyk'
                    v-model='backCmyk'
                    v-if='back.cmyk.length'
                )

                //- Rückseite » HKS
                dropdown-field.column(
                    label='Rückseite » HKS'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='back.hks'
                    v-model='backHks'
                    v-if='back.hks.length'
                )

                //- Rückseite » Pantone
                dropdown-field.column(
                    label='Rückseite » Pantone'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='back.pantone'
                    v-model='backPantone'
                    v-if='back.pantone.length'
                )

                //- Rückseite » RAL
                dropdown-field.column(
                    label='Rückseite » RAL'
                    optionValue='value'
                    optionLabel='value'
                    v-bind:options='back.ral'
                    v-model='backRal'
                    v-if='back.ral.length'
                )

            .sixteen.wide.column
                input(type='text' v-bind:value='colorCode' readonly)

            //- Sonderfarben
            .sixteen.wide.column

                .field
                    label Bezeichnung der Sonderfarbe / Flächendeckungsgrad
                    text-field(
                        v-for='(color, index) in specialColors'
                        v-bind:key='index'
                        label=''
                        v-bind:value='color'
                        v-on:input='updateSpecialColor($event, index)'
                    )

            //- Sonderfarben-Actions
            .sixteen.wide.right.aligned.column
                //- Entfernen
                a.ui.right.labeled.icon.button(v-on:click='removeSpecialColor()' v-show="specialColors.length > 1")
                    i.remove.icon
                    | Feld entfernen

                //- Hinzufuegen
                a.ui.right.labeled.icon.button(v-on:click='addSpecialColor()')
                    i.right.plus.icon
                    | Weiteres Feld hinzufügen

</template>

<script>
    import DropdownField from '../../../../../form/DropdownField'
    import TextField from '../../../../../form/TextField'
    import * as R from "ramda";

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { DropdownField, TextField },

        created() {
            const timeout = Math.floor(Math.round() * 250)
            const initialChanges = {}

            // Ist nicht so richtig sauber gelöst.
            // Background ist, dass wenn mehrere Color-Fields vorhanden sind und alle ihren Initial-Wert setzen wollen
            // dass dann das letzte Color-Field die Initialwerte der anderen Felder überrschreibt.
            // Das kann jetzt noch immer passieren ist, aber eher selten. Hoffen wir das Beste
            // Naja @TODO
            window.setTimeout(() => {

                // ggf. Default-Wert setzen
                if (R.any(R.propEq("id", this.field.id))) {
                    initialChanges[this.field.id] = this.field.defaultValue
                }

                // ggf. leere Sonderfarbe
                if (this.specialColors.length === 0) {
                    initialChanges[`${this.field.id}-0-sonderfarbe-1`] = ""
                }

                if (!R.isEmpty(initialChanges)) {
                    this.$emit("input", R.merge(this.value, initialChanges))
                }

            }, timeout)


        },

        computed: {

            back() {
                const side = R.defaultTo({}, this.field.back)
                return {
                    cmyk:    R.defaultTo([], side.cmyk),
                    hks:     R.defaultTo([], side.hks),
                    pantone: R.defaultTo([], side.pantone),
                    ral:     R.defaultTo([], side.ral),
                }
            },

            backCmyk: {
                get() { return this.getColor(4) },
                set(value) { this.updateColor(4, value) }
            },

            backHks: {
                get() { return this.getColor(5) },
                set(value) { this.updateColor(5, value) }
            },

            backPantone: {
                get() { return this.getColor(6) },
                set(value) { this.updateColor(6, value) }
            },

            backRal: {
                get() { return this.getColor(7) },
                set(value) { this.updateColor(7, value) }
            },

            colorCode() {
                const front = Number(this.frontCmyk) + Number(this.frontHks) + Number(this.frontRal) + Number(this.frontPantone)
                const back  = Number(this.backCmyk) + Number(this.backHks) + Number(this.backRal) + Number(this.backPantone)
                return `${front}/${back}`
            },

            colorValue: {
                get() {
                    return R.compose(

                        // ggf. statischen Default-Wert zurueckgeben
                        // undefined -> "0/0/0/0 0/0/0/0"
                        R.defaultTo("0/0/0/0 0/0/0/0"),

                        // ggf. Default-Wert zurueckgeben
                        // undefined -> "4/0/0/0 0/0/0/0"
                        R.defaultTo(this.field.defaultValue),

                        // Nach Farb-Value suchen
                        // { banner-1-1: "foo", banner-1-2: "3/0/0/0 0/0/0/0" } -> "3/0/0/0 0/0/0/0"
                        R.prop(this.field.id)

                    )(this.value)
                },
                set(value) {
                    this.updateColor(this.field.id, value)
                }
            },

            front() {
                const side = R.defaultTo({}, this.field.front)
                return {
                    cmyk:    R.defaultTo([], side.cmyk),
                    hks:     R.defaultTo([], side.hks),
                    pantone: R.defaultTo([], side.pantone),
                    ral:     R.defaultTo([], side.ral),
                }
            },

            frontCmyk: {
                get() { return this.getColor(0) },
                set(value) { this.updateColor(0, value) },
            },

            frontHks: {
                get() { return this.getColor(1) },
                set(value) { this.updateColor(1, value) }
            },

            frontPantone: {
                get() { return this.getColor(2) },
                set(value) { this.updateColor(2, value) }
            },

            frontRal: {
                get() { return this.getColor(3) },
                set(value) { this.updateColor(3, value) }
            },

            isBackSideVisible() {
                const side    = R.defaultTo({}, this.field.back)
                const cmyk    = R.defaultTo([], side.cmyk).length
                const hks     = R.defaultTo([], side.hks).length
                const pantone = R.defaultTo([], side.pantone).length
                const ral     = R.defaultTo([], side.ral).length
                return cmyk + hks + pantone + ral > 0
            },

            isFrontSideVisible() {
                const side    = R.defaultTo({}, this.field.front)
                const cmyk    = R.defaultTo([], side.cmyk).length
                const hks     = R.defaultTo([], side.hks).length
                const pantone = R.defaultTo([], side.pantone).length
                const ral     = R.defaultTo([], side.ral).length
                return cmyk + hks + pantone + ral > 0
            },

            specialColors() {
                const idPrefix = `${this.field.id}-0-sonderfarbe-`

                return R.compose(

                    // ggf. Default-Wert setzen
                    // undefined => []
                    R.defaultTo([]),

                    // Sonderfarbe-Werte lesen
                    // [ [ "form-1-1-1-0-sonderfarbe-1", "x" ] ] => [ "x" ]
                    R.map(R.nth(1)),

                    // Sonderfarbe-Tupel des aktuellen Farbfelds filtern
                    // > [ [ "form-1-1-1-0-sonderfarbe-1", "x" ], [ "form-1-2", "y" ] ]
                    // < [ [ "form-1-1-1-0-sonderfarbe-1", "x" ] ]
                    R.filter(pair => R.startsWith(idPrefix, pair[0])),

                    // Values in Tupel umwandeln
                    // > { "form-1-1-1-0-sonderfarbe-1": "x", "form-1-2": "y" }
                    // < [ [ "form-1-1-1-0-sonderfarbe-1", "x" ], [ "form-1-2", "y" ] ]
                    R.toPairs

                )(this.value)
            }

        },

        methods: {

            addSpecialColor() {
                const nextIndex = this.specialColors.length + 1
                const nextId    = `${this.field.id}-0-sonderfarbe-${nextIndex}`
                this.$emit('input', R.assoc(nextId, "", this.value))
            },

            getColor(position) {
                return R.compose(

                    // ggf. Leerstring zurueckgeben
                    // undefined -> ""
                    R.defaultTo(""),

                    // Wert an Position `position` holen
                    // [ "0", "2", "0", "0", "0", "0", "0", "0" ] -> "2"
                    R.nth(position),

                    // Werte-String in Werte-Array teilen
                    // "0/2/0/0/0/0/0/0" -> [ "0", "2", "0", "0", "0", "0", "0", "0" ]
                    R.split("/"),

                    // Leerzeichen ersetzen
                    // "0/2/0/0 0/0/0/0" -> "0/2/0/0/0/0/0/0"
                    R.replace(" ", "/")

                )(this.colorValue)

            },

            removeSpecialColor() {
                const lastIndex = this.specialColors.length
                const lastId    = `${this.field.id}-0-sonderfarbe-${lastIndex}`
                this.$emit('input', R.dissoc(lastId, this.value))
            },

            updateColor(position, value) {
                R.compose(

                    value => this.$emit("input", R.assoc(this.field.id, value, this.value)),

                    // `,` durch `/` ersetzen
                    // "0,0,0,0 0,0,0,0" -> "0/0/0/0 0/0/0/0"
                    R.replace(/,/g, "/"),

                    // Vorder- und Rückseite in String verbinden
                    // [ [ "0", "2", "0", "0" ], [ "0", "0", "0", "0" ] ] -> "0,2,0,0 0,0,0,0"
                    R.join(" "),

                    // Farbe für Vorder- und Rückseite teilen
                    // [ "0", "2", "0", "0", "0", "0", "0", "0" ] -> [ [ "0", "2", "0", "0" ], [ "0", "0", "0", "0" ] ]
                    R.splitAt(4),

                    // Farbe auf Position `position` aktualisieren
                    // [ "0", "0", "0", "0", "0", "0", "0", "0" ] -> [ "0", "2", "0", "0", "0", "0", "0", "0" ]
                    R.update(position, value),

                    // Werte-String in Werte-Array teilen
                    // "0/0/0/0/0/0/0/0" -> [ "0", "0", "0", "0", "0", "0", "0", "0" ]
                    R.split("/"),

                    // Leerzeichen ersetzen
                    // "0/0/0/0 0/0/0/0" -> "0/0/0/0/0/0/0/0"
                    R.replace(" ", "/")

                )(this.colorValue)

            },

            updateSpecialColor(value, index) {
                const id = `${this.field.id}-0-sonderfarbe-${index+1}`
                this.$emit('input', R.assoc(id, value, this.value))
            },

            updateValue(target, value) {
                this.$emit('input', R.assoc(target, value, this.value))
            }

        },

        props: {

            field: {
                type: Object,
                required: true
            },

            value: {
                required: true
            }

        }
    }

</script>
